import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { AssetDetailView } from '@atom/types/inventory';
import { TaskMaterialItem } from '@atom/types/task';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';

import classes from './materialModal.module.css';

export interface Props {
  material: TaskMaterialItem;
  totalRemaining: number;
}

const MaterialModalTitle = ({ material, totalRemaining }: Props) => {
  const [, { Link }] = useNavigation();

  const convertNumberToLocaleString = (input: string | number): string => {
    return Number(input).toLocaleString('en-US');
  };

  return (
    <div className={classes.materialHeader}>
      <div>
        <div className={classes.materialTitle}>{material?.name}</div>
        <div className={classes.materialSubtext}>
          <span>{numberToLocaleString(material?.rate)}</span>
          <span>/</span>
          <span className={classes.materialUnit}>{material?.unit}</span>
          {material.isStockBased && (
            <>
              <span> - </span>
              <span>{`${convertNumberToLocaleString(totalRemaining)} `}</span>
              <span
                className={classes.materialUnit}
              >{`${material?.unit} `}</span>
              <span>Remaining</span>
            </>
          )}
        </div>
      </div>
      <Link
        to={`/inventory/${material?.assetId}?activeView=${AssetDetailView.COST}`}
      >
        <IconButton>
          <Icon>launch</Icon>
        </IconButton>
      </Link>
    </div>
  );
};

export default MaterialModalTitle;
